import { createTheme } from "@nextui-org/react";
import fgvLogo from "../assets/fgv-logo.jpg";
import tueLogo from "../assets/tue-logo.svg";

export enum Skin {
  FGV = 'FGV',
  TUE = 'TUE'
}

export const getSkin = (workshopId?: string): Skin => {
  if (workshopId === "0" || workshopId === "AzNjo88oHxt1vWKXVKB2") {
    return Skin.FGV;
  }

  return Skin.TUE
}

const fgvTheme = createTheme({
  type: "light",
  theme: {
    // Default blue theme
  }
});

const tueTheme = createTheme({
  type: "light",
  theme: {
    colors: {
      primary: '#C8102E', // TUe Scarlet
      primaryLight: '#FCE8E8',
      primaryLightHover: '#FAD1D1',
      primarySolidHover: '#A00D25',
      primarySolidContrast: '#FFFFFF',
      primaryShadow: '#C8102E',

      link: '#C8102E',
    }
  }
});

export const getTheme = (workshopId?: string) => {
  return getSkin(workshopId) === Skin.TUE ? tueTheme : fgvTheme;
};

export const getLogo = (workshopId?: string) => {
  return getSkin(workshopId) === Skin.TUE ? tueLogo : fgvLogo;
};
